/** @format */

export enum FooterVariant {
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
}
